/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { adminDeleteSpecificUser } from "@services/users.service";
import { getValue } from "@utils/lodash";
import "./user.scss";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { useNavigate } from "react-router-dom";
import PaginationPage from "@components/pagination/pagination";
import NavigationBar from "@components/NotificationBar";
import { toast } from "react-toastify";
import DeleteModal from "@_common/deleteModal";
import Notfound from "@components/Not-Found";
import {
  adminCreateGroup,
  adminGetGroups,
  adminUpdateBulkGroupStatus,
  adminUpdateSpecificGroup,
} from "@services/groups.service";
import Search from "@components/common/Search";
import InputField from "@_common/InputRuleFeild";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import {
  addAllCronsConfig,
  adminAllCrons,
  adminAllCronsConfig,
  adminReRunCron,
  updateAllCronsConfig,
} from "@services/license.service";
import { formatText } from "@_common/format-text";
import moment from "moment";
import NoAccessPage from "@components/common/NoAccess";
import ScrollableReactTable from "@components/ScrollableDatatable";
import MoreAdminSvgComponent from "../../../assets/svg-components/left-menu/more-admin";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import RefreshSvgComponent from "../../../assets/svg-components/refresh";
import ReactTooltip from "react-tooltip";
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { config } from "../../../env";
// import ConfigEntityNotFoundSvgComponent from "assets/svg-components/not-found/config-entity";
import ConfigSettingComponent from "../../../assets/svg-components/sub-header/setting";

interface IAdminUsersProps {}

const AdminCron: React.FunctionComponent<IAdminUsersProps> = (props: any) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [usersList, setUsersList] = React.useState<[]>([]);
  const [group_name, setGroup_name] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [configRequest, setConfigRequest] = useState({
    module: "",
    is_enabled: false,
  });
  const [configData, setConfigData] = useState<any[]>([]);

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleOpenSettingModel = () => {
    setIsOpenSetting(!isOpenSetting);
  };

  const handleModalCancel = () => {
    setIsOpen(!isOpen);
    setEdit(false);
    setEditId("");
    setGroup_name("");
  };

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setConfigRequest({
      ...configRequest,
      [name]: value,
    });
  };
  const handleModalEdit = (item: object) => {
    setEdit(true);
    setGroup_name(getValue(item, `group_name`, ""));
    setEditId(getValue(item, `id`, ""));
    handleModal();
  };
  const [allStatus] = useState([
    { value: "", label: "All" },
    { value: "STARTED", label: "Started" },
    { value: "STOPPED", label: "Stopped" },
    { value: "SUCCESS", label: "Success" },
    { value: "FAILED", label: "Failed" },
  ]);

  const [request, setRequest] = useState({
    cron_status: "",
    cron_id: null,
  });

  const [cronStatusList] = useState([
    { id: 1, value: "VENDOR_CHECKPOINT_TASK", label: "Vendor Checkpoint Task" },
    { id: 2, value: "LICENSE_TASK", label: "License Task" },
    { id: 3, value: "MATERIALIZE_TASK", label: "Materialize Task" },
    { id: 4, value: "SELF_COMPLIANCE", label: "Self Compliance" },
    { id: 5, value: "SELF_COMPLIANCE_TASK", label: "Self Compliance Task" },
    {
      id: 6,
      value: "SELF_COMP_EMAIL_REMINDER",
      label: "Self Comp Email Reminder",
    },
    {
      id: 7,
      value: "SELF_COMP_EMAIL_REMINDER_RETRY",
      label: "Self Comp Email Reminder Retry",
    },
    {
      id: 8,
      value: "VENDOR_RELEASE_DATE_REMINDER",
      label: "Vendor Release Date Reminder",
    },
    {
      id: 9,
      value: "VENDOR_CHECKPOINT_CUTOFF_REMINDER",
      label: "Vendor Checkpoint Cutoff Reminder",
    },
    {
      id: 10,
      value: "VENDOR_RELEASE_DATE_CARRY_FORWARD",
      label: "Vendor Release Date Carry Forward",
    },
    {
      id: 11,
      value: "LICENSE_TASK_EMAIL_REMINDER",
      label: "License Task Email Reminder",
    },
    { id: 12, value: "INTERNAL_COMPLIANCE", label: "Internal Compliance" },
    {
      id: 13,
      value: "INTERNAL_COMPLIANCE_TASK",
      label: "Internal Compliance Task",
    },
    {
      id: 14,
      value: "INTERNAL_COMP_EMAIL_REMINDER",
      label: "Internal Comp Email Reminder",
    },
  ]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getConfigSettingData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  useEffect(() => {
    if (props.permissionAPITriggered && configData.length > 0) {
      getData();
    }
  }, [configData, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const enabledModules = configData.filter(
      (item) => item.is_enabled === true
    );
    if (enabledModules.length === 0) {
      setUsersList([]);
      setTotalCount(0);
      setIsLoading(false);
      return;
    }
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await adminAllCrons(queryRequest);
      if (resp.statusCode === 200) {
        setUsersList(
          getValue(resp, `data.cron_data`, []).map((item: object) => ({
            ...item,
            status: getValue(item, `status`, "")
              ? formatText(getValue(item, `status`, ""))
              : "",
            module_formatted: getValue(item, `module`, "")
              ? formatText(getValue(item, `module`, ""))
              : "",
            created_at: getValue(item, `created_at`, "")
              ? moment
                  .utc(getValue(item, `created_at`, ""))
                  .format("DD MMM YYYY, hh:mm a")
              : "",
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setUsersList([]);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getConfigSettingData = async () => {
    try {
      setIsLoading(true);
      let resp = await adminAllCronsConfig();
      if (resp) {
        const responseData = getValue(resp, "data", resp);
        setConfigData(responseData);
        if (Array.isArray(responseData) && responseData.length > 0) {
          const config = responseData[0];
          setConfigRequest({
            module: getValue(config, "module", ""),
            is_enabled: getValue(config, "is_enabled", false),
          });
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (edit) {
      try {
        let resp = await adminUpdateSpecificGroup(editId, {
          group_name: group_name,
        });
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          handleModal();
          getData();
          setGroup_name("");
          setEdit(false);
          setEditId("");
        }
      } catch (error) {}
    } else {
      try {
        let resp = await adminCreateGroup({ group_name: group_name });
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          handleModal();
          getData();
          setGroup_name("");
        }
      } catch (error) {}
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setSearchInput(e.target.value);

    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (value) {
      let payload = {
        ...params,
        status: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.status;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      usersList.length > 0
        ? usersList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // handleModalEdit(getValue(obj, `original`, ""));
  };

  const rowClickUpdate = () => {};

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificUser(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string, module: string) => {
    navigate(`/admin/schedules/logs/${id}/${module}`);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Job ID",
        accessor: "job_id",
        width: 150,
        Cell: ({ row }: any) => {
          return (
            // <div onClick={() => handleModalEdit(row.original)}>
            <p>{getValue(row, `values.job_id`, "")}</p>
            // </div>
          );
        },
      },
      {
        Header: "Module",
        accessor: "module_formatted",
        width: 250,
      },
      {
        Header: "Description",
        accessor: "description",
        width: 450,
      },
      {
        Header: "Success Count",
        accessor: "success_count",
        width: 100,
      },
      {
        Header: "Failed Count",
        accessor: "failed_count",
        width: 100,
      },
      {
        Header: "Total Count",
        accessor: "total_count",
        width: 100,
      },
      {
        Header: "Create At",
        accessor: "created_at",
        width: 250,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 150,
      },
      {
        Header: "Action",
        width: 170,
        Cell: ({ row }: any) => {
          return (
            getValue(row, `original.status`, "") === "Created" && (
              <>
                {/* <Button
								color="primary"
								onClick={() => handleEdit(row.original.id,row.original.module)}
							>
								View Logs
							</Button> */}
                <img
                  onClick={() =>
                    handleEdit(row.original.id, row.original.module)
                  }
                  src="/images/description_back.svg"
                  className="img-fluid"
                  alt=""
                />
              </>
            )
          );
        },
      },
    ],
    []
  );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminUpdateBulkGroupStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const handleSubmitRerunCron = async () => {
    try {
      // Get the selected item's ID from cronStatusList
      const selectedItem = cronStatusList.find(
        (item) => item.value === request.cron_status
      );
      if (!selectedItem?.id) {
        return;
      }
      const payload = {
        id: selectedItem.id,
        domain: config.SOURCE,
      };

      let queryRequest = QueryRequestHelper(payload);

      const response = await adminReRunCron(selectedItem.id.toString());
      // const response = await adminReRunCron(queryRequest);
      if (response) {
        toast.success(getValue(response, `message`, ""));
        console.log("Cron rerun successful:", response);
        setRequest({
          ...request,
          cron_status: "",
          cron_id: null,
        });
        handleModal();
        getData();
      }
    } catch (error) {}
  };

  const handleToggleEnabled = async (item: any) => {
    const newStatus = !item.is_enabled;
    const oldStatus = item.is_enabled;

    setConfigData((prev) =>
      prev.map((i) =>
        i.module === item.module ? { ...i, is_enabled: newStatus } : i
      )
    );
    try {
      let response;
      if (item.id) {
        response = await updateAllCronsConfig(item.id, {
          is_enabled: newStatus,
        });
      } else {
        response = await addAllCronsConfig({
          module: item.module,
          is_enabled: newStatus,
        });
      }

      if (response.statusCode === 200) {
        toast.success(getValue(response, `message`, ""));
        getConfigSettingData();
      }
    } catch (error) {
      console.error("Error updating config:", error);
      setConfigData((prev) =>
        prev.map((i) =>
          i.module === item.module ? { ...i, is_enabled: oldStatus } : i
        )
      );
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "admin_system_schedule"
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            {/* <div className="dashboard-wrapper__header">
              <h4 className="dashbaord-wrapper__header-title">Schedules</h4>
            </div> */}
            {getValue(selectedIDs, `length`, 0) > 0 && (
              <NavigationBar
                selectedIDs={selectedIDs}
                isMarkInactiveSectionVisible={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                handleChangeActiveStatus={handleChangeActiveStatus}
                text={"MARK INACTIVE"}
                multi={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                handleRemoveNavItems={handleRemoveNavItems}
                permissions={getValue(props, `permissions`, [])}
              />
            )}
            <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="header-parent-icon-holder">
                  <MoreAdminSvgComponent />
                </div>

                <div className="title-wrapper">
                  <h6 className="dashbaord-wrapper__header-parent-title">
                    Admin
                  </h6>
                  <h4 className="dashbaord-wrapper__header-title">Schedules</h4>
                </div>
              </div>
              {getValue(props, `permissions`, []).includes("create") ? (
                <div className="d-flex justify-content-end align-items-center gap-2 ">
                  <button
                    onClick={() => handleOpenSettingModel()}
                    className="icons-btn border-0 bg-light p-2 rounded"
                    data-tip
                    data-for="configTooltip"
                  >
                    <ConfigSettingComponent />
                    <ReactTooltip
                      id="configTooltip"
                      effect="solid"
                      place="bottom"
                    >
                      Configure Setting
                    </ReactTooltip>
                  </button>

                  <button
                    onClick={() => handleModal()}
                    className="icons-btn border-0 bg-light p-2 rounded"
                    data-tip
                    data-for="checkTest"
                  >
                    <RefreshSvgComponent size={24} color="#5F6368" />
                    <ReactTooltip id="checkTest" effect="solid" place="bottom">
                      Re-Run Cron
                    </ReactTooltip>
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className={`main-page-layout-wrapper has-module-filter`}>
              <div className="admin-wrapper position-relative module-filter-wrapper">
                <section className="w-100 d-flex align-items-center justify-content-between ">
                  <div className="dashboard-wrapper__input-field">
                    <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                      <label htmlFor="is_configured" className="floating-label">
                        Configuration Type
                      </label>
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder={"Select Status"}
                        options={allStatus}
                        onChange={(e: any) =>
                          handleChangeStatus(
                            getValue(e, `value`, "") ? e.value : ""
                          )
                        }
                        value={allStatus.filter(
                          (item: any) => item.value === params.status
                        )}
                        className={"inputSelect"}
                        isClear
                        customClass="module_filter_dropdown_wrapper"
                      />

                      {/* <SearchableDropdownSelect
                        placeholder={"Select Status"}
                        options={allStatus}
                        handleChange={(e: any) =>
                          handleChangeStatus(
                            getValue(e, `value`, "") ? e.value : ""
                          )
                        }
                        handleClick={(e: any) =>
                          handleChangeStatus(
                            getValue(e, `value`, "") ? e.value : ""
                          )
                        }
                        value={
                          allStatus.filter(
                            (item: any) => item.value === item.status
                          )
                        }
                        className="form-control"
                        name="status"
                        label="label"
                        id="id"
                      /> */}
                    </div>
                  </div>
                  {/* <div>.</div>
							<div className="add-filter-wrapper__filter d-flex align-items-center">
								<Search
									searchInput={search_text}
									showSearchTextbox={showSearchTextbox}
									toggleSearch={toggleSearch}
									toggleSearchClose={toggleSearchClose}
									handleChangeSearch={handleChangeSearch}
								/>
							</div> */}
                </section>
              </div>

              <div className="admin-wrapper">
                {isLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : usersList.length > 0 ? (
                  getValue(props, `permissions`, []).includes("update") ? (
                    <ScrollableReactTable
                      columns={columns}
                      data={usersList}
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={check}
                      selectedIDs={selectedIDs}
                      checkboxlogo
                      getTrProps={getTrProps}
                    />
                  ) : (
                    <ScrollableReactTable
                      columns={columns}
                      data={usersList}
                      getTableState={getTableState}
                      rowClick={rowClickUpdate}
                      check={check}
                      selectedIDs={selectedIDs}
                      checkboxlogo
                      getTrProps={getTrProps}
                    />
                  )
                ) : (
                  <>
                    <>
                      {Object.keys(params).length !== 0 ? (
                        <Notfound />
                      ) : (
                        <Notfound />
                      )}
                    </>
                  </>
                )}
              </div>
              <div className="footer-wrapper d-flex justify-content-between">
                {usersList.length > 0 && (
                  <img
                    src="/images/building-illustration.svg"
                    className="img-fluid"
                    alt=""
                  />
                )}
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <p className="show-rows-count mt-3 d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </p>
                )}
              </div>
              <DeleteModal
                isOpen={isDelete}
                handleModal={handleDelete}
                handleSubmit={handleDeleteFunction}
                deleteValue={deleteValue}
              />

              <Modal centered isOpen={isOpen} className=" modal-sm">
                <ModalBody>
                  <h3 className="mb-4 text-center">Re Run Cron</h3>
                  <div className="">
                    <div className="headcount-popup-wrapper__form-group">
                      <Label className="headcount-popup-wrapper__form-label">
                        Cron List
                      </Label>

                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Enter Cron List"
                        className="form-control w-100"
                        name="cron_status"
                        id="cron_status"
                        value={cronStatusList.filter(
                          (item) =>
                            item.value === getValue(request, `cron_status`, "")
                        )}
                        options={cronStatusList}
                        onChange={(e: any) =>
                          setRequest({
                            ...request,
                            cron_status: e.value,
                          })
                        }
                        label="Cron List"
                      />
                    </div>
                  </div>
                  <div
                    className="add-popup-wrapper__cta-wrapper mt-3"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      onClick={handleModal}
                      className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
                    >
                      Cancel
                    </button>
                    <button
                      className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
                      onClick={handleSubmitRerunCron}
                    >
                      Submit
                    </button>
                  </div>
                </ModalBody>
              </Modal>

              {/* Configure Setting */}

              <Modal centered isOpen={isOpenSetting} className="modal-md">
                <ModalHeader toggle={handleOpenSettingModel}>
                  <h4 className="text-center">Configure Setting</h4>
                </ModalHeader>
                <ModalBody
                  style={{
                    maxHeight: "500px",
                    overflowY: "auto",
                    paddingRight: "10px",
                  }}
                >
                  {configData.length > 0 ? (
                    <>
                      <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2 px-2">
                        <h6 className="mb-0 fw-bold flex-grow-1">
                          Module Name
                        </h6>
                        <h6 className="mb-0 fw-bold ms-5">Enable Status</h6>
                      </div>

                      {configData.map((item: any) => (
                        <div
                          key={item.id ?? item.module}
                          className="d-flex justify-content-between align-items-center mb-4 px-2"
                        >
                          <label className="checkpoint-active-details__label mb-0 flex-grow-1">
                            {item.module}
                          </label>

                          <div className="d-flex align-items-center ms-5">
                            <div className="choicelist-wrapper custom-switch-wrapper">
                              <label className="switch mb-0">
                                <input
                                  type="checkbox"
                                  checked={item.is_enabled}
                                  onChange={() => handleToggleEnabled(item)}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <p className="text-center text-muted">
                      No configuration data found.
                    </p>
                  )}
                </ModalBody>
              </Modal>
            </div>

            {/* <Modal
						isOpen={isOpen}
						centered

						// toggle={isOpen}
					>
						<section className="add-popup-wrapper">
							<div className="add-popup-wrapper__popup p-5">
								<div className="add-popup-wrapper__form-group form-group">
									<h3>Groups</h3>
								</div>
								<InputField
									inputType="TEXT"
									value={group_name}
									onChange={(e: any) => setGroup_name(e.target.value)}
									name="group_name"
									id="group_name"
									placeholder={"Enter Group Name"}
								/>
								<div className="add-popup-wrapper__cta-wrapper">
									<button
										onClick={handleModalCancel}
										className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
									>
										Cancel
									</button>
									<button
										className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
										onClick={handleSubmit}
									>
										Submit
									</button>
								</div>
							</div>
						</section>
					</Modal> */}
          </>
        )}
      </DashboardLayout>{" "}
    </>
  );
};

export default AdminCron;
